<!--
    @Author : Luo
    @Time   : 2020/7/14 17:26
-->
<template>
  <div class="slide_menu">
    <div class="slide_menu_container flex_center">
      <router-link v-for="(item, i) in slideMenuDate" :key="i" :to="item.url" class="text_left"
                   exact-active-class="exact-active" active-class="active">
        <label>{{ item.name }}</label>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'slideMenu',
  data () {
    return {
      slideMenuDate: [
        {name: '数据概览', url: '/home/date'},
        {name: '帐号概览', url: '/home/user'},
        {name: '视频概览', url: '/home/video'}
      ]
    }
  }
}
</script>

<style scoped>
.slide_menu {padding-top: 8px;max-width: 244px;min-width: 244px;background-color: rgba(64, 64, 64, 1);min-height: calc(100vh - 80px)}
.slide_menu_container {flex-flow: column;justify-content: flex-start;align-items: flex-start}
.slide_menu_container a {color: rgba(255, 255, 255, 1);width: calc(100% - 32px);line-height: 52px;height: 52px;padding-left: 32px}
.exact-active, .active {background-color: rgba(76, 139, 255, 1);color: rgba(255, 255, 255, 1)}
</style>



// WEBPACK FOOTER //
// src/components/slide-menu/index.vue